import { Version } 			from './../../services/Version'
import { AIAgent } 			from './../../services/AIAgent'
import { Server } 			from './../../services/Server'
import { Notifications } 	from './../../services/Notifications'

// Примесь компонента AIAgent.vue: файлы, отправляемые в чат (перетаскивание на чат, выбор в диалоге, разбор zip / html и отправка на сервер)
export default {
	data() {

		// dragenter / dragleave приходят и от дочерних элементов - считаем вложенность, чтобы слой не мигал
		this.attachmentsDragCounter = 0;

		return {
			// Над чатом перетаскиваются файлы (показываем слой с подсказкой)
			attachmentsDragging: false,
			// Файлы, добавленные для отправки: разобранные файлы, файлы, которые нельзя отправить, и исходные файлы (для проверки ограничений)
			pendingAttachments: [],
			pendingSkippedAttachments: [],
			pendingSourceFiles: [],
			// Идёт разбор файлов (распаковка zip, извлечение base64 из html) и их отправка на сервер ({done, total} или null)
			attachmentsPreparing: false,
			attachmentsUploading: null
		};

	},
	methods: {
		onAttachmentsDragEnter(event) {

			if (!this.isAttachmentsDrag(event)) return;

			event.preventDefault();

			this.attachmentsDragCounter++;

			this.attachmentsDragging = true;

		},
		// Перетаскиваются именно файлы (а не текст или элементы страницы) и чат развёрнут
		isAttachmentsDrag(event) {

			return !this.collapsed && !!event.dataTransfer && _.includes(Array.from(event.dataTransfer.types || []), 'Files');

		},
		onAttachmentsDragOver(event) {

			if (!this.isAttachmentsDrag(event)) return;

			// Без preventDefault браузер не разрешит сбросить файлы
			event.preventDefault();

			event.dataTransfer.dropEffect = 'copy';

			this.attachmentsDragging = true;

		},
		onAttachmentsDragLeave() {

			if (!this.attachmentsDragging) return;

			this.attachmentsDragCounter = Math.max(0, this.attachmentsDragCounter - 1);

			if (!this.attachmentsDragCounter) this.attachmentsDragging = false;

		},
		onAttachmentsDrop(event) {

			if (!this.isAttachmentsDrag(event)) return;

			// Иначе браузер откроет файл или вставит его имя в textarea
			event.preventDefault();

			this.attachmentsDragCounter = 0;
			this.attachmentsDragging = false;

			this.addAttachments(Array.from(event.dataTransfer.files || []));

		},
		// Добавляет файлы к отправке (перетащенные или выбранные в диалоге): проверяет ограничения (с учётом уже добавленных), распаковывает zip и извлекает base64 ассеты из html
		async addAttachments(files) {

			if (!files.length || this.attachmentsPreparing || this.attachmentsUploading) return;

			let limitsError = AIAgent.checkAttachmentsLimits(files, this.pendingSourceFiles);

			if (limitsError) return Notifications.showError(limitsError);

			this.attachmentsPreparing = true;

			try {

				let result = await AIAgent.prepareAttachments(files);

				this.pendingSourceFiles = this.pendingSourceFiles.concat(files);
				this.pendingAttachments = this.pendingAttachments.concat(result.entries);
				this.pendingSkippedAttachments = this.pendingSkippedAttachments.concat(result.skipped);

			} catch (e) {

				Notifications.showError(`Files can't be read: ${e?.message || e}`);

			} finally {

				this.attachmentsPreparing = false;

			}

		},
		removePendingAttachment(entry) {

			AIAgent.releaseAttachmentPreview(entry);

			this.pendingAttachments = _.without(this.pendingAttachments, entry);

			// Исходный файл больше не учитывается в ограничениях, когда удалены все извлечённые из него файлы
			if (!_.some(this.pendingAttachments, {source: entry.source})) {

				this.pendingSourceFiles = _.without(this.pendingSourceFiles, entry.source);
				this.pendingSkippedAttachments = _.reject(this.pendingSkippedAttachments, {source: entry.source});

			}

		},
		clearPendingAttachments() {

			_.each(this.pendingAttachments, entry => AIAgent.releaseAttachmentPreview(entry));

			this.pendingAttachments = [];
			this.pendingSkippedAttachments = [];
			this.pendingSourceFiles = [];

		},
		// Файлы отправляются по HTTP по одному, затем сервер записывает в чат сообщение с их описанием и запускает анализ файлов ИИ агентом
		async sendAttachments(content) {

			let versionId = Version.SelectedVersion.id,
				chatId = this.chat ? this.chat.id : null,
				entries = this.pendingAttachments,
				skipped = this.pendingSkippedAttachments;

			this.attachmentsUploading = {done: 0, total: entries.length};

			let upload;

			try {

				upload = await AIAgent.uploadAttachments(entries, versionId, (done, total) => this.attachmentsUploading = {done, total});

			} catch (e) {

				Notifications.showError(`Files upload failed: ${e?.message || e}`);

				return this.attachmentsUploading = null;

			}

			this.attachmentsUploading = null;

			Server.sendToServer({
				AIAgentAttachmentsMessage: {
					chatId,
					versionId,
					uploadId: upload.uploadId,
					message: content,
					// Файлы, которые не удалось прочитать или отправить, - агент напишет о них пользователю
					skipped: _.map(skipped.concat(upload.failed), item => `${item.name}\t${item.reason}`),
					model: this.modelCodename
				}
			});

			// Миниатюры отправленных файлов нужны сообщению чата - не освобождаем их
			this.pendingAttachments = [];
			this.pendingSkippedAttachments = [];
			this.pendingSourceFiles = [];

			this.prompt = '';

			this.$nextTick(() => this.autoResizeTextarea());

			this.sending = true;

			this.refreshThinking();

		}
	}
}
